import React, { useEffect, useState } from 'react';
import "./styles.scss";

const TabsOptions = ({
   options,
   onChange,
   value,
   renderTab = defaultTab,
   currentTab
}) => {

   return (
      <div className="tabs">
         {options.map((tab) => (
            <div 
               key={tab.value} 
               className={`tabs__item tabs__item${tab.value}`} 
               onClick={() => onChange(tab)}
            >
               {renderTab(tab, currentTab.value)}
            </div>
         ))}
      </div>
   );
}

const defaultTab = (tab, currentTabValue) => {
   return (
      <button className={`tabs__button ${currentTabValue === tab.value ? "active" : ""}`}>
         {tab.label}
      </button>
   );
}

export const Tabs = ({ options, value, goTo, children }) => {
   const [currentTab, setCurrentTab] = useState(options[0]);
   const [indicatorPosition, setIndicatorPosition] = useState(0);
   const [indicatorWidth, setIndicatorWidth] = useState(0);
   const [shouldAnimateIndicator, setShouldAnimateIndicator] = useState(false);

   const onChangeHandler = (value) => {
      setCurrentTab(value);
      typeof goTo === "function" && goTo(value);
      setShouldAnimateIndicator(false); // Desativa a animação ao alterar de tab
   };

   useEffect(() => {
      // Calcula a posição e largura do indicador somente se shouldAnimateIndicator for true
      if (shouldAnimateIndicator) {
         const index = value?.value || currentTab.value;
         const tabs = document.querySelector(".tabs");
         const tab = document.querySelector(`.tabs__item${index}`);

         if (tabs && tab) {
            const leftTabsPosition = Math.round(tabs.getBoundingClientRect().left);
            const leftTabPosition = Math.round(tab.getBoundingClientRect().left);
            const diff = leftTabPosition - leftTabsPosition;

            setIndicatorWidth(Math.round(tab.getBoundingClientRect().width));
            setIndicatorPosition(diff);
         }
      }

      // Reabilita a animação após a atualização do indicador
      setShouldAnimateIndicator(true);
   }, [value?.value, currentTab.value, shouldAnimateIndicator]);

   return (
      <div className="tab-container">
         <TabsOptions
            options={options}
            value={value || options[0]}
            onChange={onChangeHandler}
            renderTab={renderTab}
            currentTab={value || currentTab}
         />
         <div className="slider">
            <div
               className={`indicator ${shouldAnimateIndicator ? "animate" : ""}`}
               style={{ left: `${indicatorPosition}px`, width: `${indicatorWidth}px` }}
            ></div>
         </div>
         {children && <div className="tabs__content">{children}</div>}
      </div>
   );
}

const renderTab = (tab, currentTab) => {
   return (
      <button className={`tabs__button ${currentTab === tab.value ? "active" : ""}`}>
         {tab.label}
      </button>
   );
};